import { publicApi } from './http';

export const fetchPublicWeather = () => publicApi.get('/weather', {
  timeout: 15000,
});
